<template>
    <AuthCard>
        <template v-slot:title>
            Reset Password
        </template>
        <template v-slot:form>
            <ValidationObserver v-slot="{ handleSubmit }">
                <form action="" @submit.prevent="handleSubmit(submit)">
                    <!-- V-validate error -->
                    <Alert v-if="error"
                           type="error"
                           :contentList="message"
                    >
                    </Alert>
                    <!-- Laravel Error -->
                    <Alert type="error"
                           v-if="!form.matches"
                           contentString="Passwords do not match"
                    />
                    <ValidationProvider name="password" rules="required|min:8|max:255" v-slot="{ errors }">
                        <v-text-field
                                type="password"
                                id="password"
                                name="password"
                                label="New Password"
                                v-model="form.password"
                                :error-messages="errors[0]"
                                outlined
                        ></v-text-field>
                    </ValidationProvider>
                    <ValidationProvider name="password-confirm" rules="required|min:8|max:255" v-slot="{ errors }">
                        <v-text-field
                                type="password"
                                id="passwordConfirm"
                                name="passwordConfirm"
                                label="Confirm New Password"
                                v-model="form.confirm"
                                :error-messages="errors[0]"
                                outlined
                        ></v-text-field>
                    </ValidationProvider>
                    <v-btn
                            width="100%"
                            height="48px"
                            color="primary"
                            type="submit"
                            class="mb-8"
                    >
                        Reset Password
                    </v-btn>
                </form>
                <v-card-actions class="Auth__secondary-actions">
                    <v-btn text to="/login">Login</v-btn>
                </v-card-actions>
            </ValidationObserver>
        </template>
    </AuthCard>
</template>
<script>
import { mapMutations } from 'vuex';
import axios from 'axios';
import router from '@/router/routes';
import Alert from '@/components/Auth/Common/Alert';
import AuthCard from '@/components/Auth/Common/AuthCard';

export default {
    components: { AuthCard, Alert },
    data() {
        return {
            error: false,
            form: {
                password: undefined,
                confirm: undefined,
                matches: true,
            },
            message: '',
        };
    },

    methods: {
        ...mapMutations({
            overlayToggle: 'overlay/toggle'
        }),

        submit() {
            this.error = false;

            if (!this.$route.query.email || !this.$route.params.token) {
                return false;
            }

            if (this.form.password !== this.form.confirm) {
                this.form.matches = false;
                return false;
            }

            // Reset the error.
            this.form.matches = true;

            this.overlayToggle(true);

            this.resetPassword()
                .then(() => {
                    router.push({ path: '/login', query: {resetSuccess: 'true'} });
                })

                .catch(error => {
                    this.message = error.data.errors;
                    this.error = true;
                    this.overlayToggle(false);
                });
        },

        resetPassword() {
            return new Promise((resolve, reject) => {
                axios.get('/sanctum/csrf-cookie')
                    .then(() => {
                        axios.post('/api/password/reset', {
                            'email': this.$route.query.email,
                            'token': this.$route.params.token,
                            'password': this.form.password,
                        })
                            .then(response => {
                                resolve(response);
                            })
                            .catch(error => {
                                reject(error);
                            });
                    });
            });
        },
    },
};
</script>
